import { Button } from '@mantine/core';
import { getFeedbackFileUrl } from '../utils/GetFeedbackFile';
import { IconDownload } from '@tabler/icons-react';

const ButtonFeedback = ({ codFaculty }) => {
  
  const handleClick = () => {
    const fileUrl = getFeedbackFileUrl(codFaculty);
    if (!fileUrl) {
      alert('No hay archivo disponible');
      return;
    }

    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank'; 
    link.rel = 'noopener noreferrer';
    link.click();
  };

  return (
    <Button onClick={handleClick} color="#228be6" leftSection={<IconDownload size={20}/>}>
      Ver devolución
    </Button>
  );
};

export default ButtonFeedback;
